module.exports = __webpack_public_path__ + "static/sport/bgi-form.1ea37ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/bgi-form.png
// module id = 1nib
// module chunks = 0